var PictureLoader = {
    margin: 50,
    pictures: [],
    addContent: function (event, content) {
        content.find('picture[data-defer]').each(function () {
            PictureLoader.pictures.push(this);
        });
        PictureLoader.checkIntersections();
    },
    removeContent: function (event, content) {
        content.find('picture[data-defer]').each(function () {
            let index = PictureLoader.pictures.indexOf(this);
            if (index > 0) PictureLoader.pictures.splice(index, 1);
        });
    },
    update: function () {
        window.requestAnimationFrame(PictureLoader.checkIntersections);
    },
    checkIntersections: function () {
        if (PictureLoader.pictures) {
            let win = $(window);
            let winWidth = win.width();
            let winHeight = win.height();
            let winX = win.scrollLeft();
            let winY = win.scrollTop();
            for (let pictureNode of PictureLoader.pictures) {
                let picture = $(pictureNode);
                if (!picture.hasClass('defer-ready')) {
                    let rect = picture[0].getBoundingClientRect();
                    if (rect.left + rect.width > winX - PictureLoader.margin
                    && rect.left < winX + winWidth + PictureLoader.margin
                    && rect.top + rect.height > winY - PictureLoader.margin
                    && rect.top < winY + winHeight + PictureLoader.margin) {
                        picture.addClass('defer-ready');
                        let content = $(picture.data('defer'));
                        picture.on('load', PictureLoader.onPictureLoaded.bind(picture));
                        content.on('load', PictureLoader.onPictureLoaded.bind(picture));
                        content.find('img').on('load', PictureLoader.onPictureLoaded.bind(picture));
                        picture.append(content);
                    }
                }
            }
        }
    },
    onPictureLoaded: function () {
        this.addClass('defer-loaded');
    }
};

$(document).on('contentAdded', PictureLoader.addContent);
$(document).on('contentRemoved', PictureLoader.removeContent);
$(document).on('contentAnimated', PictureLoader.checkIntersections);
$(window).on('scroll resize', PictureLoader.update);
